import React from 'react';
type LogoProps = {
  showName?: boolean;
  nameClassName?: string;
};
export function Logo({
  showName = true,
  nameClassName = ''
}: LogoProps) {
  return <span className="inline-flex items-center gap-3" data-id="element-166" data-mp="8v62cptcae52">
      <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md border-2 border-gold bg-navy-deep font-display text-lg font-extrabold tracking-tight text-gold" data-id="element-167" data-mp="3qamc3368xp43">
        PA
      </span>
      {showName && <span className={`flex-col leading-tight ${nameClassName || 'flex'}`} data-id="element-168" data-mp="rrpapcwbjy0k">
          <span className="whitespace-nowrap font-display text-base font-bold text-white" data-id="element-169" data-mp="rpl3akz7ogvj">PA Concreto</span>
          <span className="whitespace-nowrap text-xs font-medium text-gold" data-id="element-170" data-mp="htrnmsq7479j">& Asphalt</span>
        </span>}
    </span>;
}